export default __webpack_public_path__ + "static/media/cabdo_delivery.67867539.jpeg";